import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const HomePage = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-20">
            <div className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/cec4ec820e5875b1408705710964c6e9/bf7ba4dc6e5d094dc45da6db73245551.jpeg" 
                alt="아람산업" 
                className="h-24 w-auto object-contain mix-blend-multiply"
              />
            </div>
            <div className="hidden md:block">
              <div className="ml-10 flex items-baseline space-x-8">
                <Link to="/" className={`px-3 py-2 text-base font-medium transition-colors duration-200 ${
                  isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300'
                }`}>
                  Home
                </Link>
                <Link to="/about" className={`px-3 py-2 text-base font-medium transition-colors duration-200 ${
                  isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300'
                }`}>
                  About Us
                </Link>
                <Link to="/products" className={`px-3 py-2 text-base font-medium transition-colors duration-200 ${
                  isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300'
                }`}>
                  Products
                </Link>
                <Link to="/gallery" className={`px-3 py-2 text-base font-medium transition-colors duration-200 ${
                  isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300'
                }`}>
                  Gallery
                </Link>
                <Link to="/services" className={`px-3 py-2 text-base font-medium transition-colors duration-200 ${
                  isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300'
                }`}>
                  Services
                </Link>
                <Link to="/contact" className={`px-3 py-2 text-base font-medium transition-colors duration-200 ${
                  isScrolled ? 'text-gray-900 hover:text-teal-600' : 'text-white hover:text-teal-300'
                }`}>
                  Contact
                </Link>
              </div>
            </div>
            <div className="md:hidden">
              <button className={`p-2 rounded-md ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}>
                <i className="ri-menu-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center">
        <div 
          className="absolute inset-0 bg-contain bg-center bg-no-repeat"
          style={{
            backgroundImage: `url('https://static.readdy.ai/image/cec4ec820e5875b1408705710964c6e9/25206240ea3aa74cd43e7b3a466f4956.jpeg')`
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/10 to-black/15"></div>
      </section>

      {/* Featured Products Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">추천 제품</h2>
            <p className="text-xl text-gray-600">아람산업이 자신있게 추천하는 레저용 피싱보트</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-product-shop>
            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative">
                <img 
                  src="https://static.readdy.ai/image/cec4ec820e5875b1408705710964c6e9/99e55788f75b3b675064ad8c9879d708.jpeg"
                  alt="AR-340" 
                  className="w-full h-48 object-cover"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-teal-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    인기
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">AFB450</h3>
                <p className="text-gray-600 mb-4">레저용 피싱보트</p>
                <Link to="/products" className="text-teal-600 hover:text-teal-700 font-medium cursor-pointer">
                  자세히 보기 →
                </Link>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative">
                <img 
                  src="https://static.readdy.ai/image/cec4ec820e5875b1408705710964c6e9/812e7623d0ec439d2f37097829f615eb.jpeg"
                  alt="AFB380" 
                  className="w-full h-48 object-cover"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-orange-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                    추천
                  </span>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">AFB380</h3>
                <p className="text-gray-600 mb-4">레저용 피싱보트</p>
                <Link to="/products" className="text-teal-600 hover:text-teal-700 font-medium cursor-pointer">
                  자세히 보기 →
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA Section */}
      <section className="py-20 bg-teal-600">
        <div className="max-w-4xl mx-auto text-center px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-white mb-6">
            구매 및 제품문의는 전화로 하시면 더 빠르고 상세하게 받으실 수 있습니다.
          </h2>
          <p className="text-2xl font-bold text-white mb-8">
            아람산업 010-8970-6099
          </p>
          <Link to="/contact" className="bg-white text-teal-600 hover:bg-gray-100 px-8 py-4 rounded-lg text-lg font-medium transition-colors duration-200 whitespace-nowrap cursor-pointer">
            문의하기
          </Link>
        </div>
      </section>

      {/* Video Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">아람산업 피싱보트 AFB450 시승 영상</h2>
            <p className="text-xl text-gray-600">직접 체험해보세요</p>
          </div>
          <div className="relative aspect-video bg-gray-900 rounded-lg overflow-hidden">
            <div className="absolute inset-0 flex items-center justify-center">
              <a 
                href="https://www.youtube.com/watch?v=Zni3azQRDbk" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white/20 hover:bg-white/30 rounded-full p-6 transition-colors duration-200"
              >
                <i className="ri-play-fill text-white text-4xl"></i>
              </a>
            </div>
            <img 
              src="https://img.youtube.com/vi/Zni3azQRDbk/maxresdefault.jpg"
              alt="시승 영상" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <img 
                src="https://static.readdy.ai/image/cec4ec820e5875b1408705710964c6e9/bf7ba4dc6e5d094dc45da6db73245551.jpeg" 
                alt="아람산업" 
                className="h-12 w-auto mb-4"
              />
              <p className="text-gray-400 mb-4">
                최고 품질의 레저용 피싱보트를 제조하는 전문업체입니다.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors duration-200">
                  <i className="ri-youtube-line text-xl"></i>
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4">연락처 정보</h3>
              <div className="space-y-2 text-gray-400">
                <p>
                  <i className="ri-map-pin-line w-5 h-5 inline-flex items-center justify-center mr-2"></i>
                  울산광역시 울주군 삼동면 삼동로 470-11
                </p>
                <p>
                  <i className="ri-phone-line w-5 h-5 inline-flex items-center justify-center mr-2"></i>
                  010-8970-6099
                </p>
                <p>
                  <i className="ri-mail-line w-5 h-5 inline-flex items-center justify-center mr-2"></i>
                  doldom00700@hanmail.net
                </p>
              </div>
            </div>

            <div>
              <h3 className="text-lg font-bold mb-4">무통장입금</h3>
              <div className="space-y-2 text-gray-400">
                <p>우리은행 1002-863-603150</p>
                <p>예금주: 김종호(아람산업)</p>
              </div>
            </div>
          </div>

          <hr className="border-gray-800 my-8" />
          
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 아람산업. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0">
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-white text-sm transition-colors duration-200">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;